import STUDENT_FEATURES from './student-features.json';

// If any student under a client has access to any of these features, all students do.
const GROUPED_STUDENT_FEATURES = [
  STUDENT_FEATURES.academicVideoOnDemand,
  STUDENT_FEATURES.essayEditing,
  STUDENT_FEATURES.instantChat,
];

export default GROUPED_STUDENT_FEATURES;
